import "../../styles/pageskelton.css";
import SkeletonBox from "./SkeletonBox";

const HomeSkeleton = () => (
  <div className="sk-page">
    <SkeletonBox className="sk-header" />
    <SkeletonBox className="sk-hero" />

    {/* Events slider row */}
    <div className="conatiner">
      <SkeletonBox className="sk-section-title" />
      <SkeletonBox className="sk-section-sub" />
    </div>
    <div className="sk-home-events">
      {[1, 2, 3, 4].map((i) => (
        <SkeletonBox key={i} className="sk-event-card" />
      ))}
    </div>

    {/* 3-col section */}
    <div className="conatiner">
      <SkeletonBox className="sk-section-title" />
      <SkeletonBox className="sk-section-sub" />
      <div className="sk-home-grid">
        {[1, 2, 3].map((i) => (
          <SkeletonBox key={i} className="sk-home-grid-card" />
        ))}
      </div>
    </div>
  </div>
);

export default HomeSkeleton;
